import AppsIcon from '@mui/icons-material/Apps';
import {
  Grid,
  List,
  ListSubheader,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemButton,
} from '@mui/material';
import { VmsType } from 'wisestep-api';

const LeftNavigation = ({ vmsTypeList, setSelectedVms, selectedVms }) => {
  return (
    <Grid item xs={2}>
      <List
        sx={{ width: '100%', bgcolor: 'background.paper' }}
        component="nav"
        aria-labelledby="nested-list-subheader"
        subheader={
          <ListSubheader component="div" id="nested-list-subheader">
            INDEX
          </ListSubheader>
        }
      >
        <ListItem sx={{ fontWeight: 700, color: '#00B4D8' }}>
          <ListItemIcon sx={{ color: '#00B4D8' }}>
            <AppsIcon />
          </ListItemIcon>
          <ListItemText primary="VMS Integration" />
        </ListItem>
        {vmsTypeList.map((vmsType: VmsType, i: number) => (
          <ListItemButton
            key={vmsType.name + '_' + i}
            sx={vmsType.name === selectedVms.name ? { bgcolor: '#F2FBFD' } : {}}
            onClick={() => setSelectedVms(vmsType)}
          >
            <ListItemIcon></ListItemIcon>
            <ListItemText primary={`${vmsType.label}`} />
          </ListItemButton>
        ))}
      </List>
    </Grid>
  );
};
export default LeftNavigation;
